function openDrawerFromParam() {
  var url = new URL(window.location.href);
  if (url.searchParams.get('open_cart') !== '1') return;
  // var drawer = document.querySelector('cart-drawer');
  // if (!drawer || typeof drawer.open !== 'function') return;
  url.searchParams.delete('open_cart');
  if (typeof history.replaceState === 'function') {
    history.replaceState({}, '', url.pathname + url.search + (url.hash || ''));
  }
  document.querySelector('html').classList.add('minicart-open');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openDrawerFromParam);
} else {
  openDrawerFromParam();
}

// LQIP (Low Quality Image Placeholder) blur-up effect
// @param {Element} container - Optional container to scope the search (defaults to document)
function initLQIP(container) {
  const scope = container || document;
  // Only process images that haven't been initialized yet
  const lqipImages = scope.querySelectorAll('.media-lqip[data-lqip]:not([data-lqip-initialized])');
  
  lqipImages.forEach(function(img) {
    // Mark as initialized to avoid re-processing
    img.setAttribute('data-lqip-initialized', 'true');
    
    // Set LQIP as background immediately for instant visual feedback
    const lqipSrc = img.getAttribute('data-lqip');
    const mediaContainer = img.closest('.media-container') || img.parentElement;
    
    if (lqipSrc && mediaContainer) {
      // Preload LQIP for instant display
      const lqipImg = new Image();
      lqipImg.src = lqipSrc;
      
      // Set background immediately (LQIP is tiny, loads almost instantly)
      mediaContainer.style.backgroundImage = 'url(' + lqipSrc + ')';
      mediaContainer.style.backgroundSize = 'cover';
      mediaContainer.style.backgroundPosition = 'center';
      mediaContainer.style.backgroundRepeat = 'no-repeat';
    }
    
    // When main image loads, remove blur and fade in
    const handleImageLoad = function() {
      img.classList.add('loaded');
      // Clean up background image once main image is loaded (memory optimization)
      if (mediaContainer && mediaContainer.style.backgroundImage) {
        mediaContainer.style.backgroundImage = '';
      }
    };
    
    if (img.complete && img.naturalWidth > 0) {
      // Image already loaded
      handleImageLoad();
    } else {
      // Wait for image to load
      img.addEventListener('load', handleImageLoad, { once: true });
      
      // Also handle error case
      img.addEventListener('error', function() {
        // Remove blur even on error to show fallback
        handleImageLoad();
      }, { once: true });
      
      // Fallback: remove blur after timeout even if load event doesn't fire
      setTimeout(function() {
        if (!img.classList.contains('loaded')) {
          handleImageLoad();
        }
      }, 3000);
    }
  });
}

function handleSecondaryNav() {
  document.querySelectorAll('.has-childs').forEach(function(el) {
    el.addEventListener('click', function(e) { 
      e.preventDefault();
      el.parentElement.classList.toggle("show");    
    });
  });
}

function checkStoreSlideOrientation() {
  const storeSlides = document.querySelectorAll('.store-slide');
  
  storeSlides.forEach(function(slide) {
    const img = slide.querySelector('img, video');
    
    if (!img) return;
    
    const checkOrientation = function() {
      let width, height;
      
      if (img.tagName === 'VIDEO') {
        width = img.videoWidth;
        height = img.videoHeight;
      } else {
        width = img.naturalWidth;
        height = img.naturalHeight;
      }
      
      if (width && height) {
        slide.classList.remove('slide-vertical', 'slide-horizontal');
        
        if (height > width) {
          slide.classList.add('slide-vertical');
        } else {
          slide.classList.add('slide-horizontal');
        }
      }
    };
    
    if (img.tagName === 'VIDEO') {
      if (img.videoWidth > 0) {
        checkOrientation();
      } else {
        img.addEventListener('loadedmetadata', checkOrientation, { once: true });
      }
    } else if (img.complete && img.naturalWidth > 0) {
      checkOrientation();
    } else {
      img.addEventListener('load', checkOrientation, { once: true });
    }
  });
}
  
function setNavHeightVars() {
  var header = document.querySelector('#header');
  var mainNavContainer = document.querySelector('.main-nav-container');
  var announcementBar = document.querySelector('.announcement-bar-container');
  
  if (header) {
    var headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }
  
  if (mainNavContainer) {
    var mainNavHeight = mainNavContainer.offsetHeight;
    document.documentElement.style.setProperty('--main-nav-container-height', mainNavHeight + 'px');
  }
  
  if (announcementBar) {
    var announcementBarHeight = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
  }
}

function observeHeaderResize() {
  var header = document.querySelector('#header');
  var mainNavContainer = document.querySelector('.main-nav-container');
  var announcementBar = document.querySelector('.announcement-bar-container');
  
  if (!header) return;
  
  // Usar ResizeObserver para detectar cambios de tamaño
  var resizeObserver = new ResizeObserver(function() {
    setNavHeightVars();
  });
  
  resizeObserver.observe(header);
  
  if (mainNavContainer) {
    resizeObserver.observe(mainNavContainer);
  }
  
  if (announcementBar) {
    resizeObserver.observe(announcementBar);
  }
}

function handleClosingButtonBanner() {
  const closingButtons = document.querySelectorAll('.banner-button');
  closingButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      button.closest('.module').classList.add('hidden');
    });
  });
}

function handleProductCardSwipers() {
  const isDesktop = window.innerWidth >= 820;
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach(function(card, index) {
    const linkElement = card.querySelector('.product-card-link-media');
    const swiperWrapper = linkElement ? linkElement.querySelector('.swiper-wrapper') : null;

    if (!linkElement || !swiperWrapper || swiperWrapper.children.length <= 1) return;

    if (linkElement.dataset.swiperInitialized) return;

    // Mobile: skip Swiper only inside featured-products-list so parent can scroll
    var inFeaturedList = card.closest('.featured-products-list');
    if (!isDesktop && inFeaturedList) return;

    linkElement.classList.add('swiper', 'product-card-swiper-' + index);

    const nextButton = linkElement.querySelector('.swiper-button-next');
    const prevButton = linkElement.querySelector('.swiper-button-prev');

    const swiper = new Swiper(linkElement, {
      loop: true,
      speed: 400,
      effect: 'fade',
      spaceBetween: 0,
      grabCursor: true,
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      navigation: nextButton && prevButton ? {
        nextEl: nextButton,
        prevEl: prevButton,
      } : false,
    });

    var clickHandler = function(e) {
      if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev')) {
        e.preventDefault();
      }
    };
    var enterHandler = function() { swiper.slideNext(); };
    var leaveHandler = function() { swiper.slideTo(0); };

    linkElement.addEventListener('click', clickHandler);
    card.addEventListener('mouseenter', enterHandler);
    card.addEventListener('mouseleave', leaveHandler);

    linkElement.dataset.swiperInitialized = 'true';
    linkElement._productCardSwiperRef = { swiper: swiper, card: card, click: clickHandler, enter: enterHandler, leave: leaveHandler };
  });
}

function destroyProductCardSwipers(onlyInFeaturedList) {
  document.querySelectorAll('.product-card-link-media[data-swiper-initialized]').forEach(function(el) {
    if (onlyInFeaturedList && !el.closest('.featured-products-list')) return;
    var ref = el._productCardSwiperRef;
    if (ref) {
      ref.card.removeEventListener('mouseenter', ref.enter);
      ref.card.removeEventListener('mouseleave', ref.leave);
      el.removeEventListener('click', ref.click);
      el._productCardSwiperRef = null;
    }
    if (el.swiper && el.swiper.destroy) {
      el.swiper.destroy(true, true);
    }
    el.classList.remove('swiper');
    el.className = el.className.replace(/\bproduct-card-swiper-\d+\b/g, '').replace(/\s+/g, ' ').trim();
    el.removeAttribute('data-swiper-initialized');
  });
}

function syncProductCardSwipersWithViewport() {
  var isDesktop = window.innerWidth >= 820;
  if (isDesktop) {
    handleProductCardSwipers();
  } else {
    destroyProductCardSwipers(true);
    handleProductCardSwipers();
  }
}

function debounce(fn, ms) {
  var t;
  return function() {
    clearTimeout(t);
    t = setTimeout(fn, ms);
  };
}

function handleStoresSwipers() {
  const el = document.querySelector('.stores-swiper');
  if (!el || el.dataset.storesSwiperInit || typeof Swiper === 'undefined') return;
  const slides = el.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return;
  el.dataset.storesSwiperInit = '1';
  const swiper = new Swiper(el, {
    loop: slides.length > 1,
    speed: 1,
    spaceBetween: 0,
  });
  
  slides.forEach(function(slide) {
    slide.addEventListener('click', function() {
      swiper.slideNext();
    });
  });
}

function handleSearchModal() {
  const searchTrigger = document.querySelector('.search-trigger');
  const searchModal = document.getElementById('search-modal');
  const searchModalContent = document.querySelector('.search-modal-content');
  const body = document.body;
  
  if (!searchTrigger) return;
  
  // Toggle body class and button text when search trigger is clicked
  if (!searchTrigger.dataset.listenerAdded) {
    searchTrigger.dataset.listenerAdded = 'true';
    searchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      body.classList.toggle('search-open');
      
      // Update button text based on state
      if (body.classList.contains('search-open')) {
        searchTrigger.textContent = 'Close';
      } else {
        searchTrigger.textContent = 'Search';
      }
    });
  }
  
  // Close search modal when clicking on the backdrop
  const searchModalBackdrop = document.querySelector('.search-modal-backdrop');
  if (searchModalBackdrop && !searchModalBackdrop.dataset.backdropListenerAdded) {
    searchModalBackdrop.dataset.backdropListenerAdded = 'true';
    searchModalBackdrop.addEventListener('click', function() {
      if (body.classList.contains('search-open')) {
        body.classList.remove('search-open');
        const trigger = document.querySelector('.search-trigger');
        if (trigger) trigger.textContent = 'Search';
      }
    });
  }

  if (!body.dataset.searchScrollCloseListenerAdded) {
    body.dataset.searchScrollCloseListenerAdded = 'true';
    window.addEventListener('scroll', function() {
      if (!body.classList.contains('search-open')) return;
      body.classList.remove('search-open');
      const trigger = document.querySelector('.search-trigger');
      if (trigger) trigger.textContent = 'Search';
    }, { passive: true });
  }
}

function handleScrollDirection() {
  let lastScrollTop = 0;
  const body = document.body;
  const header = document.querySelector('#header');

  // Function to check scroll position
  const checkScroll = function() {
    if (document.documentElement.classList.contains('open-menu')) return;
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;
    const headerHeight = header ? header.offsetHeight : 0;
    const scrollableHeight = scrollHeight - clientHeight;

    // Short page: not enough content to scroll meaningfully. Never hide the header
    // to avoid hide/show flicker when the only scroll is a few pixels.
    if (scrollableHeight <= headerHeight) {
      body.classList.add('to-top');
      body.classList.remove('scroll');
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      return;
    }

    const isAtBottom = currentScroll + clientHeight >= scrollHeight - 10; // 10px threshold

    if (currentScroll === 0) {
      // At the top
      body.classList.add('to-top');
      body.classList.remove('scroll');
      body.classList.remove('scrolling');
    } else if (isAtBottom) {
      // At the bottom - keep scroll class, don't toggle
      body.classList.add('scroll');
      body.classList.remove('to-top');
    } else if (currentScroll > lastScrollTop) {
      // Scrolling down
      body.classList.add('scroll');
      body.classList.add('scrolling');
      body.classList.remove('to-top');
    } else {
      // Scrolling up
      body.classList.remove('scroll');
      body.classList.remove('to-top');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  // Check on initial load
  checkScroll();

  // Check on scroll
  window.addEventListener('scroll', checkScroll);
}

function handleProductOptionsButton() {
  const form = document.getElementById('product-form');
  const submitButton = form ? form.querySelector('button[type="submit"]') : null;
  
  if (!form || !submitButton) return;
  
  // Get all option inputs
  const optionInputs = form.querySelectorAll('.product-variant-input');
  
  // If no options/variants, enable the button
  var defaultAddLabel = form.dataset.preOrderDate ? (form.dataset.preOrderLabel || '') : (form.dataset.addToCartLabel || '');
  if (optionInputs.length === 0) {
    submitButton.disabled = false;
    submitButton.textContent = defaultAddLabel;
    submitButton.classList.remove('select-size');
    return;
  }
  
  // Check if any option is selected
  function checkOptionsSelected() {
    let allSelected = true;
    
    // Group inputs by name to check radio buttons correctly
    const selectInputs = Array.from(optionInputs).filter(input => input.tagName === 'SELECT');
    const radioGroups = {};
    
    optionInputs.forEach(function(input) {
      if (input.type === 'radio') {
        radioGroups[input.name] = false;
      }
    });
    
    // Check selects
    selectInputs.forEach(function(select) {
      if (!select.value || select.value.trim() === '') {
        allSelected = false;
      }
    });
    
    // Check radio groups and update selected classes
    optionInputs.forEach(function(input) {
      if (input.type === 'radio') {
        const radioContainer = input.closest('.radio-container');
        if (input.checked) {
          radioGroups[input.name] = true;
          if (radioContainer) {
            radioContainer.classList.add('selected');
          }
          input.classList.add('selected');
        } else {
          if (radioContainer) {
            radioContainer.classList.remove('selected');
          }
          input.classList.remove('selected');
        }
      }
    });
    
    // Verify all radio groups have selection
    Object.values(radioGroups).forEach(function(isSelected) {
      if (!isSelected && Object.keys(radioGroups).length > 0) {
        allSelected = false;
      }
    });
    
    // Enable/disable button based on selection
    var addLabel = form.dataset.preOrderDate ? (form.dataset.preOrderLabel || '') : (form.dataset.addToCartLabel || '');
    var selectSizeLabel = form.dataset.selectSizeLabel || '';
    if (allSelected && (selectInputs.length > 0 || Object.keys(radioGroups).length > 0)) {
      submitButton.disabled = false;
      submitButton.textContent = addLabel;
      submitButton.classList.remove('select-size');
    } else {
      submitButton.disabled = true;
      submitButton.textContent = selectSizeLabel;
      submitButton.classList.add('select-size');
    }
  }
  
  // Listen for changes on all option inputs
  optionInputs.forEach(function(input) {
    input.addEventListener('change', checkOptionsSelected);
  });
  
  // Initial check
  checkOptionsSelected();
}

function handleMobileMenuTrigger() {
  const menuTrigger = document.querySelector('.mobile-menu-trigger');
  const menuContainer = document.querySelector('.main-nav-container');

  function preventBodyTouchMove(e) {
    if (menuContainer && menuContainer.contains(e.target)) return;
    e.preventDefault();
  }

  if (menuTrigger) {
    const menuSpan = menuTrigger.querySelector('span:first-child');
    const closeSpan = menuTrigger.querySelector('span:last-child');
    const html = document.documentElement;

    menuTrigger.addEventListener('click', function() {
      if (menuSpan.style.display === 'none') {
        menuSpan.style.display = '';
        closeSpan.style.display = 'none';
        html.classList.remove('open-menu');
        document.removeEventListener('touchmove', preventBodyTouchMove, { passive: false });
      } else {
        menuSpan.style.display = 'none';
        closeSpan.style.display = '';
        html.classList.add('open-menu');
        document.addEventListener('touchmove', preventBodyTouchMove, { passive: false });
      }
    });
  }
}

function handleFooterMenuToggle() {
  const footerTitles = document.querySelectorAll('.footer-link-item .footer-title:not(.footer-ethic-title)');
  
  footerTitles.forEach(function(title) {
    title.addEventListener('click', function() {
      const footerLinkItem = title.closest('.footer-link-item');
      footerLinkItem.classList.toggle('footer-link-open');
    });
  });

  const ethicButton = document.querySelector('.footer-ethic-button');
  if (ethicButton) {
    const ethicContainer = ethicButton.closest('.ethic-container');

    ethicButton.addEventListener('click', function() {
      if (ethicContainer) {
        ethicContainer.classList.toggle('ethic-open');
      }
    });
  }
}



function initNewsletterSuccessHide() {
  var successResponse = document.getElementById('mce-success-response');
  if (!successResponse) return;
  var newsletterContent = successResponse.closest('.newsletter-content');
  if (!newsletterContent) return;
  var formWrapper = newsletterContent.querySelector('.newsletter-form-wrapper');
  if (!formWrapper) return;
  var form = newsletterContent.querySelector('form');
  var emailInput = form ? form.querySelector('input[type="email"]') : null;

  var observerOptions = {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style']
  };

  function resetForm() {
    window.removeEventListener('pagehide', clearResetTimeout);
    resetTimeoutId = null;
    formWrapper.removeAttribute('hidden');
    successResponse.textContent = '';
    successResponse.style.display = 'none';
    if (emailInput) emailInput.value = '';
    observer.observe(successResponse, observerOptions);
  }

  var resetTimeoutId;

  function checkSuccess() {
    if (successResponse.textContent.trim() !== '' || window.getComputedStyle(successResponse).display !== 'none') {
      formWrapper.setAttribute('hidden', '');
      observer.disconnect();
      resetTimeoutId = setTimeout(resetForm, 5000);
      window.addEventListener('pagehide', clearResetTimeout);
      return true;
    }
    return false;
  }

  function clearResetTimeout() {
    if (resetTimeoutId) clearTimeout(resetTimeoutId);
    window.removeEventListener('pagehide', clearResetTimeout);
  }

  var observer = new MutationObserver(function() {
    if (checkSuccess()) observer.disconnect();
  });
  observer.observe(successResponse, observerOptions);
}

function initSwymCollectionButtons() {
  function swymCollectionButtonsCallback(swat) {
    swat.initializeActionButtons('.product-grid');
    swat.initializeActionButtons('#swym-custom-wishlist-button');
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCollectionButtonsCallback);
}

function handleCookieManagePrefsState() {
  if (document.body.dataset.cookiePrefsListenerAdded) return;
  document.body.dataset.cookiePrefsListenerAdded = 'true';

  document.addEventListener('click', function(event) {
    const managePrefsButton = event.target.closest('#shopify-pc__banner__btn-manage-prefs');
    const bannerWrapper = document.querySelector('.shopify-pc__banner__wrapper');
    if (!bannerWrapper) return;

    if (managePrefsButton) {
      bannerWrapper.classList.add('prefs-open');
      return;
    }

    const closePrefsButton = event.target.closest('#shopify-pc__prefs__header-close');
    if (closePrefsButton) {
      bannerWrapper.classList.remove('prefs-open');
    }
  });
}

function initCookieBannerClassToggle() {
  var root = document.documentElement;
  var body = document.body;
  if (!root || !body) return;
  var discoveryObserver = null;
  var bannerObserver = null;

  function isVisible(el) {
    if (!el) return false;
    if (el.hidden) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getBannerNodes() {
    var banner = document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner');
    var dialog = document.querySelector('.shopify-pc__banner__dialog');
    if (!banner && dialog) {
      banner = dialog.closest('#shopify-pc__banner, .shopify-pc__banner') || dialog.parentElement;
    }
    return { banner: banner, dialog: dialog };
  }

  function syncCookieBannerClass() {
    var nodes = getBannerNodes();
    var banner = nodes.banner;
    var dialog = nodes.dialog;
    var isOpen = isVisible(banner) && isVisible(dialog);
    root.classList.toggle('cookie-banner-open', isOpen);
    body.classList.toggle('cookie-banner-open', isOpen);
  }

  function connectBannerObserver() {
    if (bannerObserver) return;
    bannerObserver = new MutationObserver(function() {
      syncCookieBannerClass();
    });
    bannerObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
  }

  function startDiscoveryObserver() {
    if (discoveryObserver) return;
    discoveryObserver = new MutationObserver(function() {
      var nodes = getBannerNodes();
      if (!nodes.banner && !nodes.dialog) return;
      connectBannerObserver();
      if (discoveryObserver) {
        discoveryObserver.disconnect();
        discoveryObserver = null;
      }
      syncCookieBannerClass();
    });
    discoveryObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  var initialNodes = getBannerNodes();
  if (initialNodes.banner || initialNodes.dialog) {
    connectBannerObserver();
    syncCookieBannerClass();
  } else {
    startDiscoveryObserver();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Calcular la altura del header y asignarla a la variable CSS
  handleSecondaryNav();
  setNavHeightVars();
  observeHeaderResize();
  // Show/hide the collection nav immediately (before heavy image/swiper work)
  handleScrollDirection();
  initLQIP();
  checkStoreSlideOrientation();
  handleClosingButtonBanner();
  handleProductCardSwipers();
  window.addEventListener('resize', debounce(syncProductCardSwipersWithViewport, 150));
  handleStoresSwipers();
  handleSearchModal();
  handleProductOptionsButton();
  handleMobileMenuTrigger();
  handleFooterMenuToggle();
  initNewsletterSuccessHide();
  initSwymCollectionButtons();
  handleCookieManagePrefsState();
  initCookieBannerClassToggle();
});

// Wait for all resources to load before calculating header height
window.addEventListener('load', function() {
  setNavHeightVars();
  var main = document.querySelector('main');
  if (main) main.classList.add('loaded');
});
